/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TOTPRegisterChallengeOptions
 */
export interface TOTPRegisterChallengeOptions {
    /**
     * 
     * @type {string}
     * @memberof TOTPRegisterChallengeOptions
     */
    key_uri: string;
    /**
     * 
     * @type {string}
     * @memberof TOTPRegisterChallengeOptions
     */
    qr_code_data_b64: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TOTPRegisterChallengeOptions
     */
    recovery_codes: Array<string>;
}

/**
 * Check if a given object implements the TOTPRegisterChallengeOptions interface.
 */
export function instanceOfTOTPRegisterChallengeOptions(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "key_uri" in value;
    isInstance = isInstance && "qr_code_data_b64" in value;
    isInstance = isInstance && "recovery_codes" in value;

    return isInstance;
}

export function TOTPRegisterChallengeOptionsFromJSON(json: any): TOTPRegisterChallengeOptions {
    return TOTPRegisterChallengeOptionsFromJSONTyped(json, false);
}

export function TOTPRegisterChallengeOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TOTPRegisterChallengeOptions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key_uri': json['key_uri'],
        'qr_code_data_b64': json['qr_code_data_b64'],
        'recovery_codes': json['recovery_codes'],
    };
}

export function TOTPRegisterChallengeOptionsToJSON(value?: TOTPRegisterChallengeOptions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key_uri': value.key_uri,
        'qr_code_data_b64': value.qr_code_data_b64,
        'recovery_codes': value.recovery_codes,
    };
}

